module.exports = __webpack_public_path__ + "img/career-grid-bg-1.76aca2f3.jpg";